'use strict';

class ReportFormProducts {
  constructor($scope, reportService, Notification) {
    this.$scope = $scope;
    this.reportService = reportService;
    this.Notification = Notification;
  }

  $onInit() {
    this.results = {};
    this.details = [];
    this.columns = [];
    this.selectedColumns = [];
    this.params = {
      columns: [],
      from: moment().startOf('month').format('DD.MM.YY'),
      to: moment().endOf('month').format('DD.MM.YY'),
      format: 'JSON'
    };

    this.exportColumns = [];
    this.reportService.availableColumns('payments/products')
      .then((json) => {
        let cols = [];

        json.data.forEach((item) => {
          cols.push(item.key);
        });

        this.exportColumns = cols;
      });

    this.loadColumns();
  }

  checkType(val) {
    return this.reportService.checkType(val);
  }

  preview() {
    if (this.params.columns.length) {
      this.reportService.generate('payments/products',
        {
          columns: this.params.columns.join(','),
          from: moment(this.params.from, 'DD.MM.YY').format('YYYY-MM-DD'),
          to: moment(this.params.to, 'DD.MM.YY').format('YYYY-MM-DD'),
          format: 'JSON'
        })
        .then((resp) => {
          if (resp.status === 204) {
            this.results = {};
            this.details = [];
            this.Notification.info('Det var ingen fakturaer i valgt periode.');
          } else {
            this.results = resp.data;
            this.details = [];
            this.load();
          }
        });
    }
  }

  load() {
    this.reportService.availableColumns('payments/products/exceptions')
      .then((json) => {
        let cols = [];

        json.data.forEach((item) => {
          cols.push(item.key);
        });

        return cols;
      })
      .then((columns) => {
        this.reportService.generate(`payments/products/exceptions`,
          {
            columns: columns.join(','),
            from: moment(this.params.from, 'DD.MM.YY').format('YYYY-MM-DD'),
            to: moment(this.params.to, 'DD.MM.YY').format('YYYY-MM-DD'),
            format: 'JSON'
          })
          .then((resp) => {
            if (resp.status !== 204) {
              this.details.push(resp.data);
            }
          });
      });
  }

  loadColumns() {
    this.columns = [];

    this.reportService.availableColumns('payments/products')
      .then((resp) => {
        this.columns = resp.data;
        this.results = {};

        // preselect
        this.selectedColumns = [];
        resp.data.forEach((c) => {
          this.selectColumn(c.key);
        }, this);
      });
  }

  selectColumn(key) {
    if ($.inArray(key, this.selectedColumns) === -1) {
      this.selectedColumns.push(key);
    } else {
      let index = this.selectedColumns.indexOf(key);
      this.selectedColumns.splice(index, 1);
    }

    angular.extend(this.params, {
      columns: this.selectedColumns
    });
  }

  download(format, email = false) {
    let params = {
      format: format,
      columns: this.exportColumns.join(','),
      from: moment(this.params.from, 'DD.MM.YY').format('YYYY-MM-DD'),
      to: moment(this.params.to, 'DD.MM.YY').format('YYYY-MM-DD')
    };

    if (email) {
      params.email = this.email;
    }

    this.reportService.download('payments/products', params, email)
      .then((resp) => {
        if (resp) {
          this.Notification.success(`Rapporten er sendt til ${this.email}`);
        }
      });
  }
}

ReportFormProducts.$inject = ['$scope', 'reportService', 'Notification'];

const reportFormProducts = {
  bindings: {
    email: '<'
  },
  controller: ReportFormProducts,
  template: `
    <h2>Innbetalinger per produkt</h2>

    <p>N.B.: Kun innbetalinger som stemmer med utestående beløp grupperes automatisk på produktnummer. Andre betalinger finnes på avvikslisten og må håndteres manuelt.</p>

    <div report-generator ng-model="$ctrl.params"></div>

    <fieldset>
      <label for="email">E-postadresse</label>
      <input id="email" name="email" type="email" ng-model="$ctrl.email">
    </fieldset>

    <button ng-click="$ctrl.preview()" class="button">Vis</button>

    <div ng-show="$ctrl.results.items.length">
      <a href ng-click="$ctrl.download('XLS')" class="button secondary"><i class="fa fa-file-o"></i> Last ned</a>

      <a ng-show="$ctrl.email" href ng-click="$ctrl.download('XLS', true)" class="button secondary"><i class="fa fa-envelope-o"></i> Send på e-post</a>

      <table class="responsive">
        <thead>
          <tr>
            <th ng-repeat="(key, value) in $ctrl.results.headers" ng-bind="value"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="item in $ctrl.results.items track by $index">
            <td class="nowrap" ng-repeat="(key, value) in item" ng-bind="$ctrl.checkType(value)"></td>
          </tr>
        </tbody>
      </table>

      <h3 class="subheader">Avviksliste</h3>

      <table ng-repeat="details in $ctrl.details track by $index" ng-if="details && details.headers" class="responsive">
        <thead>
          <tr>
            <th ng-repeat="(key, value) in details.headers" ng-bind="value"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="item in details.items track by $index">
            <td class="nowrap" ng-repeat="(key, value) in item" ng-bind="$ctrl.checkType(value)"></td>
          </tr>
        </tbody>
      </table>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('reportFormProducts', reportFormProducts)
  .config(($routeProvider) => {
    $routeProvider
      .when('/rapport/produkt', {
        title: 'Innbetalinger per produkt',
        template: '<report-form-products email="$resolve.email" />',
        secure: true,
        resolve: {
          email: (originatorService) => originatorService.get().then((resp) => resp.data.contact.email)
        }
      });
  });
